import { BaseApiClient } from '../base';
import { API_ENDPOINTS } from '../endpoints';
import { supportChatIdentitySchema, type SupportChatIdentity } from '@aica/api-types';

export class SupportApi extends BaseApiClient {
  /**
   * Identity for the Bitrix24 support-chat widget. In embedded mode the path is
   * rewritten to /api/v1/embedded/support/chat-identity by useEmbeddedAuthFetch,
   * so callers never branch on the surface.
   *
   * Validated: `customData` is intentionally loosely typed in the schema (it's
   * Bitrix24's own block format, not ours), so this catches a malformed
   * envelope (missing hash/orgId, non-array customData) but not a malformed
   * block inside it — useSupportChatIdentity guards that separately.
   */
  async getChatIdentity(): Promise<SupportChatIdentity> {
    return this.validatedRequest<SupportChatIdentity>(
      API_ENDPOINTS.SUPPORT_CHAT_IDENTITY,
      supportChatIdentitySchema
    );
  }
}
